class EmailSection extends React.Component {
  
  render() {
    
    var inputs = [];
    inputs.push(
      <input key="email" type="text" className="email" placeholder="Email address" name="email" />
    );
    
    inputs.push(
      <input key="submit" type="submit" className="submit border_btn white" value="I'm in" />
    );
    
    inputs.push(
      <input key="hidden" type="hidden" id="events" name="events" value="events" />
    );
    
    if (this.props.isMobile) {
      inputs.push(
        <input key="location" type="hidden" id="signup_location" name="signup_location" value="mobile_scroll_post1" />
      );
    } else {
      inputs.push(
        <input key="location" type="hidden" id="signup_location" name="signup_location" value="email_breaker_form" />
      );
    }
    
    console.log("inputs :", inputs);

    return (
      <section className="popular_posts row">
      <div>
        <div className="row gutter_left gutter_right" style={{marginTop: "20px"}}>
          <div className="updates_form breaker_updates_form">
      
            <form id="updates">
              <div className="header mono_heading size_21">
                Come through for today’s top stories
              </div>
      
              <div className="signup">
                {inputs}
              </div>
            </form>
               
          </div>
        </div>
      </div>
     </section>
    );
  }
}
